import { InfoCircleOutlined, UserOutlined } from '@ant-design/icons'
import { useMutateHook } from '@thesisedu/feature-react'
import { Row } from '@thesisedu/web'
import { AutoComplete, Col, Form, Input, Tabs } from 'antd'
import React from 'react'

import { LABEL_PLACEHOLDER, SEGMENT_GROUPS } from '../../constants'
import { Editor } from '../../editor/Editor'
import { SegmentType } from '../../schema'
import { EditableSegment } from '../../segment/EditableSegment'
import { MutateGroupSegmentFields, SegmentProps } from '../../types'

export function GroupEdit(props: SegmentProps) {
  const additionalFields = useMutateHook<MutateGroupSegmentFields>(
    'courses-react:mutate-group-fields',
    [],
    props,
  )
  return (
    <EditableSegment
      {...props}
      addTypes={[SegmentType.Section, SegmentType.Group, SegmentType.Reference, 'Assignment']}
    >
      {({ childrenFields, submitFields, segment }) => (
        <Row>
          <Col xs={24} md={8} lg={6}>
            <Form.Item
              label={'Label'}
              name={['config', 'label']}
              initialValue={segment.config.label}
              rules={[{ required: true, message: 'A label is required.' }]}
            >
              <AutoComplete
                dataSource={SEGMENT_GROUPS}
                filterOption={(inputValue, option) =>
                  option?.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                placeholder={LABEL_PLACEHOLDER}
              />
            </Form.Item>
            <Form.Item
              label={'Index'}
              name={'index'}
              initialValue={segment.index}
              rules={[
                {
                  validator: (rule, value, callback) => {
                    if (value?.toString().includes(' ')) {
                      callback('Index cannot contain spaces.')
                    } else callback()
                  },
                },
              ]}
            >
              <Input style={{ width: 100 }} placeholder={'1-1'} />
            </Form.Item>
            <Form.Item
              label={'Name'}
              name={'name'}
              initialValue={segment.name}
              rules={[{ required: true, message: 'A group name is required.' }]}
            >
              <Input />
            </Form.Item>
            {childrenFields}
            {additionalFields}
            {submitFields}
          </Col>
          <Col xs={24} md={16} lg={18}>
            <Tabs defaultActiveKey={'student'}>
              <Tabs.TabPane
                forceRender
                tab={
                  <span>
                    <UserOutlined /> Student View
                  </span>
                }
                key={'student'}
              >
                <Form.Item
                  name={['config', 'studentContent']}
                  initialValue={segment.config.studentContent || []}
                >
                  <Editor id={`${segment.id}-student`} />
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane
                forceRender
                tab={
                  <span>
                    <InfoCircleOutlined /> Teacher View
                  </span>
                }
                key={'teacher'}
              >
                <Form.Item
                  name={['config', 'teacherContent']}
                  initialValue={segment.config.teacherContent || []}
                >
                  <Editor id={`${segment.id}-teacher`} />
                </Form.Item>
              </Tabs.TabPane>
            </Tabs>
          </Col>
        </Row>
      )}
    </EditableSegment>
  )
}
